/** @jsxImportSource @emotion/react */
import parse from 'parse-json';
import { css } from '@emotion/react';
import { hooks as commonHooks, types as commonTypes } from '@sitebuilder/common';
import {
    getTextSchemaProperties,
    getStyleSchemaProperties,
    getLayoutSchemaProperties,
} from '../utils';
import RiskMetricTable, { RiskMetricProps } from './RiskMetricTable';
import riskMetricTableStyles, { riskMetricTableThemeStyles } from './RiskMetricTable.styles';
import sampleData from './sampleData.json';

interface WidgetProperties extends commonTypes.WidgetPropertiesBase, RiskMetricProps {}

const RiskMetricTableWrapper = (props: commonTypes.WidgetInstanceProps) => {
    const widgetProperties = commonHooks.useWidgetProperties<WidgetProperties>(
        props.widgetInstanceId
    );
    const { styles, title, headings, tableData } = widgetProperties || props;
    const { data } = props;
    const theme = data?.themeSelected || props?.theme;

    const i18n = commonHooks.useLocalization();

    const titleBinding = i18n.format(title || 'Risk metrics table', data);
    const headingsBinding = headings && parse(i18n.format(headings, data));
    const tableDataBinding = tableData && parse(i18n.format(tableData || '', data));

    return (
        <div
            className={widgetProperties?.typographyClass ? widgetProperties.typographyClass : ''}
            css={css`
                ${!theme
                    ? riskMetricTableStyles
                    : riskMetricTableThemeStyles}${getTextSchemaProperties(
                    widgetProperties,
                    data?.colorSpace
                )}${getStyleSchemaProperties(widgetProperties)}${getLayoutSchemaProperties(
                    widgetProperties
                )}${styles || ''}
            `}
        >
            <RiskMetricTable
                title={titleBinding}
                headings={headingsBinding || sampleData.riskMetrics.headings}
                tableData={tableDataBinding || sampleData.riskMetrics.data}
            />
        </div>
    );
};

export default RiskMetricTableWrapper;
